import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import {
  rgba, timingFunctions, adjustHue, mix
} from 'polished';
import { OutboundLink } from 'gatsby-plugin-google-analytics';

import { baseFont, colors } from '../styles/theme';
import mq from '../styles/mq';

export const Title = ({ children }) => (
  <h1
    css={mq({
      fontSize: ['2rem', '3rem'],
      fontWeight: 300,
      lineHeight: 1,
      letterSpacing: '-0.025em',
      margin: '1rem 0',
    })}
  >
    {children}
  </h1>
);

export const SmallTitle = ({ children }) => (
  <h6
    css={{
      position: 'relative',
      fontFamily: `'IBM Plex Mono', ${baseFont}`,
      fontSize: 13,
      fontWeight: 800,
      textTransform: 'uppercase',
      letterSpacing: 3,
      lineHeight: 1,
      marginBottom: '3rem',
      color: colors.pr.gray400,
    }}
  >
    <span
      css={{
        position: 'relative',
        display: 'inline-block',
        '&:before': {
          content: '""',
          top: '40%',
          width: 20,
          height: 0,
          position: 'absolute',
          left: '100%',
          marginLeft: '0.5em',
          borderTop: `1px solid ${colors.pr.gray400}`,
        },
        '&:after': {
          content: '""',
          top: '40%',
          width: 200,
          height: 0,
          position: 'absolute',
          left: '100%',
          marginLeft: '0.5em',
          borderTop: `1px solid ${colors.pr.gray400}`,
          opacity: 0.3,
        },
      }}
    >
      {children}
    </span>
  </h6>
);

export const SubTitle = styled.div(
  p => css`
    color: ${colors.pr.gray500};
    font-size: ${p.size ? p.size : '1.5rem'};
    font-weight: 300;
    line-height: 1.25;
  `
);

export const infoOverlay = css`
  text-align: left;
  padding: 1rem;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  transition: all 0.3s ${timingFunctions('easeInOutQuart')};
  background: linear-gradient(to top, ${rgba('#000', 0.7)}, ${rgba('#000', 0.1)});
  color: #fff;
  text-shadow: 0 1px 0 ${rgba('#000', 0.3)};
  opacity: 0;
  transform: scale(1.15);
  transform-origin: bottom;

  @media (max-width: 480px) {
    opacity: 1;
    transform: scale(1);
  }
`;

export const RedDot = props => (
  <span
    css={{
      color: colors.primary,
      fontWeight: 500,
    }}
    {...props}
  >
    {props.char ? props.char : '.'}
  </span>
);

export const SocLink = styled(OutboundLink)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2em;
  height: 2em;
  border: 1px solid;
  border-radius: 50%;
  color: #fff !important;
  text-decoration: none;
  transition: all 0.2s ${timingFunctions('easeInOutQuart')};
  margin-right: 0.5rem;

  &:hover {
    transform: scale(1.2);
  }
`;

export const HiddenText = styled.span`
  font-size: 0.001px;
  opacity: 0;
`;
